let lenisInstance = null;

export const setLenis = (instance) => {
  lenisInstance = instance;
};

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) {
    if (window.location.pathname !== '/') window.location.href = `/${id}`;
    return;
  }
  if (lenisInstance) {
    lenisInstance.scrollTo(el, { offset: -64, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: 'smooth' });
  }
};
